import React from 'react';
import { Outlet } from 'react-router-dom';
import {Layout} from "antd";
import '../../../../../assets/scss/theme/admin/style.scss';

export const AuthLayout: React.FC = () => {
    return (
        <Layout id={"admin-theme-wrapper"} className="app-wrapper auth-app-wrapper admin-theme-wrapper">
            <Layout className="auth-layout">
                <Layout.Content className="content-wrapper">
                    <div className="main-content">
                        <Outlet />
                    </div>
                </Layout.Content>
            </Layout>
        </Layout>
    )
}